<script setup lang="ts">
import { ref } from "vue";

import IconWhiteCross from "@/components/icons/white/IconWhiteCross.vue";
import { useSiteStateStore } from "@/stores";

const siteStateStore = useSiteStateStore();

const isOpen = ref<boolean>(true);

const closeBanner = () => {
  isOpen.value = false;
  siteStateStore.hasBanner = false;
};

/* eslint-disable @intlify/vue-i18n/no-raw-text */
</script>

<template>
  <div v-if="isOpen" class="banner">
    <div class="container d-flex">
      <span class="banner__text-container">
        <b>VIGTIG OPDATERING</b>
        inden prøven i retskrivning. Er du lærer, og har du ordblinde elever?
        <a
          href="/download-exam-information?mtm_campaign=exam-2025&mtm_kwd=abc-banner"
          target="_blank"
          class="banner__link"
        >
          Hent <b>opdateret</b> PDF
        </a>
      </span>
      <button class="btn banner__button" @click="closeBanner()">
        <IconWhiteCross class="banner__icon"></IconWhiteCross>
      </button>
    </div>
  </div>
</template>
